<template>
  <div id="overview" ref="overview">
    <div class="top">
      <div class="top-content">
        <!-- <div class="name">设备总览</div> -->
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="TopTab">
          <el-tab-pane label="设备概况" name="overview"></el-tab-pane>
          <el-tab-pane label="实时数据" name="realtime"></el-tab-pane>
          <el-tab-pane label="故障分析" name="analysis"></el-tab-pane>
        </el-tabs>
        <div class="right-content">
          <div class="time">{{ time }}</div>
          <div class="controls">
            <div class="pill-switch" :class="{ active: isAutoLoop }" @click="toggleAutoLoop">
              <div class="switch-track">
                <div class="switch-knob" :class="{ active: isAutoLoop }"></div>
              </div>
              <span class="switch-label">{{ isAutoLoop ? '页轮播' : '页暂停' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 页签1：设备概况 -->
    <div v-show="activeTab === 'overview'">
      <el-row :gutter="10" style="padding: 0 10px;">
        <el-col :span="5">
          <div class="left-top border">
            <div class="number">
              <div>总数</div>
              <div class="num_box"><span class="num">{{ AllCnt }}</span>台</div>
            </div>
            <div class="number">
              <div>生产中</div>
              <div class="num_box"><span class="num">{{ ProcCnt }}</span>台</div>
            </div>
            <div class="number">
              <div>待机中</div>
              <div class="num_box"><span class="num">{{ WaitCnt }}</span>台</div>
            </div>
            <div class="number">
              <div>故障中</div>
              <div class="num_box"><span class="num">{{ ErrCnt }}</span>台</div>
            </div>
            <div class="number" style="border: none;">
              <div>关机中</div>
              <div class="num_box"><span class="num">{{ CloseCnt }}</span>台</div>
            </div>
          </div>
          <div class="pie border">
            <div class="progress" :style="'background-image: conic-gradient(#FFFFFF '+ progress1 +'%, #09AA79 ' + progress1 + '%);'">
              <div class="ctext">
                <div class="cv"><span>{{ rate }}</span>%</div>
                生产运行率
              </div>
            </div>
            <div class="progress" :style="'background-image: conic-gradient(#FFFFFF '+ progress2 +'%, #FECD0B ' + progress2 + '%);margin-top:25px;'">
                <div class="ctext">
                  <div class="cv"><span>{{ rate2 }}</span>%</div>
                  开机率
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="19">
            <div class="device-list-container">
              <!-- 设备列表轮播开关（浮动） -->
              <div class="device-loop-switch-float">
                <div class="pill-switch small" :class="{ active: isDeviceLoop }" @click="toggleDeviceLoop">
                  <div class="switch-track">
                    <div class="switch-knob" :class="{ active: isDeviceLoop }"></div>
                  </div>
                  <span class="switch-label">{{ isDeviceLoop ? '设备轮播' : '暂停' }}</span>
                </div>
              </div>
              <el-row :gutter="10">
              <el-col :span="12">
                <div class="line-box border">
                  <div class="icon"><img src="@/assets/icon01.png" /></div>
                  <span class="boxTitle">近7日生产工时排行TOP5</span>              
                  <bar-Chart ref="rankChart" :height="height" class="chart"/>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="line-box border">
                  <div class="icon"><img src="@/assets/icon01.png" /></div>
                  <span class="boxTitle">近7日生产工时趋势</span>
                  <line-Chart ref="workChart" :height="height" class="chart"/>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-top: 10px;">
              <el-col :span="8" v-for="(item,index) in deviceList" :key="index" :style="index<3?'margin-bottom:10px;':''">
                <div class="state" :class="'bg'+item.status">
                  <div style="height: 6px;margin-left: -20px;" :class="'blank'+item.status" />
                  <div class="name">{{ item.name }}</div>
                  <div class="item">
                    <div class="label" v-if="item.status==0">生产时间：</div>
                    <div class="label" v-else-if="item.status==1">待机时间：</div>
                    <div class="label" v-else-if="item.status==2">故障时间：</div>
                    <div class="label" v-else-if="item.status==3">关机时间：</div>
                    <div class="info">{{ item.time }}</div>
                  </div>
                  <div class="item">
                    <div class="label">工单号：</div>
                    <div class="info">
                      <span v-if="item.WorkDocNo">{{ item.WorkDocNo }}</span>
                      <span v-else>-</span>
                    </div>
                  </div>
                  <!-- <div class="item">
                    <div class="label">BOM版本号：</div>
                    <div class="info">
                      <span v-if="item.MouldBomNo">{{ item.MouldBomNo }}</span>
                      <span v-else>-</span>
                    </div>
                  </div> -->
                  <div class="item">
                    <div class="label">模具：</div>
                    <div class="info">
                      <span v-if="item.MouldNo">{{ item.MouldNo }}</span>
                      <span v-else>-</span>
                    </div>
                  </div>
                  <div class="btn" :class="'blank'+item.status" v-if="item.status==0">生产</div>
                  <div class="btn" :class="'blank'+item.status" v-else-if="item.status==1">待机</div>
                  <div class="btn" :class="'blank'+item.status" v-else-if="item.status==2">故障</div>
                  <div class="btn" :class="'blank'+item.status" v-else-if="item.status==3">关机</div>
                </div>
              </el-col>
            </el-row>
            </div>
          </el-col>
        </el-row>
    </div>

    <!-- 页签2：实时数据 -->
    <div v-show="activeTab === 'realtime'" class="realtime-container">
      <div class="realtime-controls">
        <el-tag type="info" size="small">第 {{ realtimePage }}/{{ realtimePageMax }} 页</el-tag>
        <div class="pill-switch" :class="{ active: isRealtimeLoop }" @click="toggleRealtimeLoop">
          <div class="switch-track">
            <div class="switch-knob" :class="{ active: isRealtimeLoop }"></div>
          </div>
          <span class="switch-label">{{ isRealtimeLoop ? '轮播：开启' : '轮播：关闭' }}</span>
        </div>
      </div>
      <el-table :data="realtimeData" border stripe :row-class-name="tableRowClassName" style="width: 100%;">
        <el-table-column prop="EquipmentName" label="机台编号" width="120" align="center"></el-table-column>
        <el-table-column prop="OperatingStatus" label="生产状态" width="100" align="center">
          <template slot-scope="{row}">
            <span v-if="row.OperatingStatus == 0">关机中</span>
            <span v-else-if="row.OperatingStatus == 1">待机中</span>
            <span v-else-if="row.OperatingStatus == 2">生产中</span>
          </template>
        </el-table-column>
        <el-table-column prop="OrderNo" label="当前生产订单" width="150" align="center"></el-table-column>
        <el-table-column prop="WorkDocNo" label="当前生产工单" width="150" align="center"></el-table-column>
        <!-- <el-table-column prop="MouldBomNo" label="BOM版号" width="120" align="center"></el-table-column> -->
        <el-table-column prop="MouldName" label="当前使用模具" width="150" align="center"></el-table-column>
        <el-table-column prop="Cycn" label="模数" width="80" align="center"></el-table-column>
        <el-table-column prop="Et1" label="温度1" width="80" align="center">
          <template slot-scope="{row}">
            <span v-if="row.Et1">{{ row.Et1 }}℃</span>
            <span v-else>-</span>
          </template>
            </el-table-column>
            <el-table-column prop="Et2" label="温度2" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et2">{{ row.Et2 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Et3" label="温度3" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et3">{{ row.Et3 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Et4" label="温度4" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et4">{{ row.Et4 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Et5" label="温度5" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et5">{{ row.Et5 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Et6" label="温度6" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et6">{{ row.Et6 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Et7" label="温度7" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et7">{{ row.Et7 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Et8" label="温度8" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et8">{{ row.Et8 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Et9" label="温度9" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et9">{{ row.Et9 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Et10" label="温度10" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Et10">{{ row.Et10 }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="Eot" label="油温" width="80" align="center">
              <template slot-scope="{row}">
                <span v-if="row.Eot">{{ row.Eot }}℃</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="realtimeData.length === 0" style="text-align: center; padding: 50px 0; color: #909399;">
            暂无数据
          </div>
    </div>

    <!-- 页签3：故障分析 -->
    <div v-show="activeTab === 'analysis'" style="padding: 10px;">
      <el-row :gutter="20">
            <!-- 设备状态分析 -->
            <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 20px;">
              <div class="analysis-card border">
                <div class="chart-header">
                  <i class="el-icon-pie-chart"></i>
                  <span>设备状态分析</span>
                </div>
                <div v-if="devStatusData.length === 0" class="no-data">暂无数据</div>
                <div v-show="devStatusData.length > 0" style="display: flex; align-items: center; flex: 1;">
                  <div ref="devStatusChart" style="width: 60%; height: 100%;"></div>
                  <div style="flex: 1; padding: 20px;">
                    <div class="status-item">
                      <div class="status-label failure-label">故障（{{ devStatusData[0]?.Value || 0 }}%）</div>
                    </div>
                    <div class="status-item">
                      <div class="status-label normal-label">非故障（{{ devStatusData[1]?.Value || 0 }}%）</div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>

            <!-- 月故障机台TOP5 -->
            <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 20px;">
              <div class="analysis-card border">
                <div class="chart-header">
                  <i class="el-icon-s-data"></i>
                  <span>月故障机台TOP5</span>
                </div>
                <div v-if="failureTopNoData" class="no-data">暂无数据</div>
                <div v-show="!failureTopNoData" ref="failureTopChart" style="width: 100%; flex: 1;"></div>
              </div>
            </el-col>

            <!-- 实时故障告警 -->
            <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 20px;">
              <div class="analysis-card border">
                <div class="chart-header">
                  <i class="el-icon-warning"></i>
                  <span>实时故障告警</span>
                </div>
                <div v-if="realtimeFailureList.length === 0" class="no-data">暂无数据</div>
                <div v-else style="padding: 10px 0; flex: 1;">
                  <el-table :data="realtimeFailureList" border stripe height="100%" size="small" class="compact-table">
                    <el-table-column prop="EquipmentNo" label="机台编号" width="100" align="center"></el-table-column>
                    <el-table-column prop="FailureTime" label="报障时间" width="140" align="center"></el-table-column>
                    <el-table-column prop="FailureRemark" label="故障描述" show-overflow-tooltip></el-table-column>
                  </el-table>
                </div>
              </div>
            </el-col>

            <!-- 周故障工时趋势图 -->
            <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 20px;">
              <div class="analysis-card border">
                <div class="chart-header">
                  <i class="el-icon-data-line"></i>
                  <span>周故障工时趋势图</span>
                </div>
                <div v-if="failureWeekNoData" class="no-data">暂无数据</div>
                <div v-show="!failureWeekNoData" ref="failureWeekChart" style="width: 100%; flex: 1;"></div>
              </div>
            </el-col>

            <!-- 周告警趋势图 -->
            <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 20px;">
              <div class="analysis-card border">
                <div class="chart-header">
                  <i class="el-icon-data-line"></i>
                  <span>周告警趋势图</span>
                </div>
                <div v-if="warnWeekNoData" class="no-data">暂无数据</div>
                <div v-show="!warnWeekNoData" ref="warnWeekChart" style="width: 100%; flex: 1;"></div>
              </div>
            </el-col>

            <!-- 月故障类型TOP5 -->
            <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 20px;">
              <div class="analysis-card border">
                <div class="chart-header">
                  <i class="el-icon-s-data"></i>
                  <span>月故障类型TOP5</span>
                </div>
                <div v-if="failureTypeNoData" class="no-data">暂无数据</div>
                <div v-show="!failureTypeNoData" ref="failureTypeChart" style="width: 100%; flex: 1;"></div>
              </div>
            </el-col>

            <!-- 当天告警类型TOP5 -->
            <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 20px;">
              <div class="analysis-card border">
                <div class="chart-header">
                  <i class="el-icon-s-data"></i>
                  <span>当天告警类型TOP5</span>
                </div>
                <div v-if="dayWarnTypeNoData" class="no-data">暂无数据</div>
                <div v-show="!dayWarnTypeNoData" ref="dayWarnTypeChart" style="width: 100%; flex: 1;"></div>
              </div>
            </el-col>

            <!-- 实时设备告警 -->
            <el-col :xs="24" :sm="12" :md="8" style="margin-bottom: 20px;">
              <div class="analysis-card border">
                <div class="chart-header">
                  <i class="el-icon-warning"></i>
                  <span>实时设备告警</span>
                </div>
                <div v-if="realtimeWarnList.length === 0" class="no-data">暂无数据</div>
                <div v-else style="padding: 0px 0; flex: 1;">
                  <el-table :data="realtimeWarnList" border stripe height="100%" size="small" class="compact-table">
                    <el-table-column prop="EquipmentNo" label="机台编号" width="100" align="center"></el-table-column>
                    <el-table-column prop="Warmtime" label="产生时间" width="140" align="center"></el-table-column>
                    <el-table-column prop="WarmMsg" label="告警信息" show-overflow-tooltip></el-table-column>
                  </el-table>
                </div>
              </div>
            </el-col>
          </el-row>
    </div>
  </div>
</template>
<script>
import lineChart from '@/components/dashboard/charts/lineChart';
import barChart from '@/components/dashboard/charts/barChart';
import screenApi from '@/api/screen';
import analysisApi from '@/api/equipment/analysis';

export default {
  name: "overview",
  components: { lineChart, barChart },
  data() {
    return {
      activeTab: 'overview', // 当前页签：overview-设备概况, realtime-实时数据, analysis-故障分析
      isAutoLoop: false, // 是否开启自动轮播（默认关闭）
      isDeviceLoop: false, // 是否开启设备列表轮播（默认关闭）
      deviceList: [],
      rate: 0,
      rate2: 0,
      resizeObserver: null,
      arr: [],
      arr2: [],
      inited: false,
      eqTimer: null,
      machinePageIndex: 1,
      machinePageMax: 0,
      AllCnt: 0,
      ProcCnt: 0,
      WaitCnt: 0,
      ErrCnt: 0,
      CloseCnt: 0,
      time: '',
      // 实时数据
      isRealtimeLoop: false, // 是否开启实时数据轮播（默认关闭）
      realtimePage: 1,
      realtimePageMax: 0,
      realtimeData: [],
      realtimeTimer: null,
      // 故障分析
      devStatusData: [], // 设备状态分析数据
      failureTopNoData: true,
      failureWeekNoData: true,
      failureTypeNoData: true,
      warnWeekNoData: true,
      dayWarnTypeNoData: true,
      realtimeFailureList: [], // 实时故障告警
      realtimeWarnList: [], // 实时设备告警
    }
  },
  computed: {
    progress1() {
      return (100 - this.rate).toFixed(1);
    },
    progress2() {
      return (100 - this.rate2).toFixed(1);
    },
    height() {
      return "275px";
    },
  },
  mounted() {
    const resizeObserver = new ResizeObserver(entries => {
      if(this.inited) {
        // 使用requestAnimationFrame确保在下一帧执行
        requestAnimationFrame(() => {
          this.resizeEC();
        });
      }
    });
    resizeObserver.observe(this.$refs.overview);
    this.nowTimes();
    // 初始化设备概况数据（默认页签）
    this.getData();
    this.$nextTick(() => {
      this.inited = true;
      // 初始加载后确保图表正确尺寸
      setTimeout(() => {
        this.resizeEC();
      }, 300);
    })
  },
  beforeDestroy() {
    if(this.resizeObserver) this.resizeObserver.disconnect();
    if(this.realtimeTimer) clearTimeout(this.realtimeTimer);
    if(this.autoLoopTimer) clearInterval(this.autoLoopTimer);
    if(this.updateInterval) clearInterval(this.updateInterval);
    if(this.eqTimer) clearTimeout(this.eqTimer);
  },
  methods: {
    handleTabClick(tab, event) {
      const tabName = tab.name || tab;

      // 页签切换时的处理
      if (tabName === 'overview') {
        // 停止设备翻页定时器
        if (this.eqTimer) {
          clearTimeout(this.eqTimer);
          this.eqTimer = null;
        }
        // 切换到设备概况时，初始化图表
        this.$nextTick(() => {
          this.initOverviewCharts();
          // 如果有多页设备且轮播开关开启，启动翻页定时器
          if (this.machinePageMax > 1 && this.isDeviceLoop) {
            this.eqLoopFunc();
          }
          // 延迟resize确保图表容器已正确显示并计算尺寸
          setTimeout(() => {
            this.resizeEC();
          }, 200);
        });
      } else if (tabName === 'realtime') {
        // 切换到实时数据时，停止设备翻页定时器
        if (this.eqTimer) {
          clearTimeout(this.eqTimer);
          this.eqTimer = null;
        }
        this.initRealtime();
      } else if (tabName === 'analysis') {
        // 切换到故障分析时，停止设备翻页定时器
        if (this.eqTimer) {
          clearTimeout(this.eqTimer);
          this.eqTimer = null;
        }
        this.initAnalysis();
      }
    },
    toggleAutoLoop() {
      this.isAutoLoop = !this.isAutoLoop;
      if (this.isAutoLoop) {
        this.startAutoLoop();
      } else {
        this.stopAutoLoop();
      }
    },
    startAutoLoop() {
      this.stopAutoLoop();
      // 停止设备翻页定时器
      if (this.eqTimer) {
        clearTimeout(this.eqTimer);
        this.eqTimer = null;
      }
      this.autoLoopTimer = setInterval(() => {
        const nextTab = this.getNextTab(this.activeTab);
        this.activeTab = nextTab;
        this.handleTabClick(nextTab);
      }, 30000); // 每30秒切换一次页签
    },
    stopAutoLoop() {
      if (this.autoLoopTimer) {
        clearInterval(this.autoLoopTimer);
        this.autoLoopTimer = null;
      }
    },
    getNextTab(currentTab) {
      if (currentTab === 'overview') return 'realtime';
      if (currentTab === 'realtime') return 'analysis';
      return 'overview';
    },
    nowTimes() {
      this.updateTime();
      this.updateInterval = setInterval(() => {
        this.updateTime();
      }, 1000);
    },
    updateTime() {
      const cd = new Date();
      this.time = 
        this.zeroPadding(cd.getFullYear(), 4) + 
        "-" + 
        this.zeroPadding(cd.getMonth() + 1, 2) + 
        "-" + 
        this.zeroPadding(cd.getDate(), 2) + 
        " " + 
        this.zeroPadding(cd.getHours(), 2) + 
        ":" + 
        this.zeroPadding(cd.getMinutes(), 2) + 
        ":" + 
        this.zeroPadding(cd.getSeconds(), 2);
    },
    zeroPadding(num, digit) {
      let zero = "";
      for (let i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    resizeEC() {
      if (this.$refs.workChart && this.$refs.rankChart) {
        this.$refs.workChart.handleResize();
        this.$refs.rankChart.handleResize();
      }
    },
    // 设备概况相关方法
    async getData() {
      // 设备概况-设备信息
      screenApi.devInfo().then(res => {
        if (res.Code == 0) {
          this.AllCnt = res.Data.AllCnt;
          this.ProcCnt = res.Data.ProcCnt;
          this.WaitCnt = res.Data.WaitCnt;
          this.ErrCnt = res.Data.ErrCnt;
          this.CloseCnt = res.Data.CloseCnt;
          this.rate = res.Data.RunRate;
          this.rate2 = res.Data.OpenRate;
        }
      })

      // 设备概况-生产时长排行Top5
      analysisApi.getRecent7DaysTop5WorkHours().then(res => {
        if (res.Code == 0) {
          this.arr = res.Data;
          if (this.$refs.rankChart) {
            this.$refs.rankChart.initChart(this.arr);
          }
        }
      })

      // 设备概况-近七天时长
      analysisApi.getRecent7DaysWorkHoursTrend().then(res => {
        if (res.Code == 0) {
          this.arr2 = res.Data;
          if (this.$refs.workChart) {
            this.$refs.workChart.initChart(this.arr2);
          }
        }
      })

      this.machinePageIndex = 1;
      await this.getMachines();

      // 初始加载时启动设备翻页定时器（如果有多页且轮播开关开启）
      if (this.machinePageMax > 1 && this.isDeviceLoop) {
        this.eqLoopFunc();
      }
    },
    // 设备列表翻页定时器
    eqLoopFunc() {
      if (this.eqTimer) clearTimeout(this.eqTimer);

      this.eqTimer = setTimeout(async () => {
        // 先判断是否需要重置到第一页
        if (this.machinePageIndex >= this.machinePageMax) {
          this.machinePageIndex = 1;
        } else {
          this.machinePageIndex++;
        }
        await this.getMachines();
        // 只有当开关开启时才继续轮播
        if (this.isDeviceLoop) {
          this.eqLoopFunc();
        } else {
          this.eqTimer = null;
        }
      }, 20000); // 每20秒切换一页
    },
    toggleDeviceLoop() {
      this.isDeviceLoop = !this.isDeviceLoop;
      if (this.isDeviceLoop) {
        // 开启轮播，启动定时器
        if (this.activeTab === 'overview' && this.machinePageMax > 1 && !this.eqTimer) {
          this.eqLoopFunc();
        }
      } else {
        // 关闭轮播，停止定时器
        if (this.eqTimer) {
          clearTimeout(this.eqTimer);
          this.eqTimer = null;
        }
      }
    },
    getMachines() {
      return new Promise((resolve, reject) => {
        var params = { PageIndex: this.machinePageIndex, PageSize: 6, EquipmentTypeId: 6, Statuses: [1, 2, 7] }
        screenApi.getEquipmentList(params).then(res => {
          if (res.Code == 0) {
            this.machinePageMax = Math.ceil(res.Count / 6);
            this.deviceList = res.Data.map(x => {
              let status = 1;
              switch (x.StateText) {
                case "生产": status = 0; break;
                case "故障": status = 2; break;
                case "关机": status = 3; break;
                case "待机": status = 1; break;
              }

              return {
                status: status,
                name: x.EquipmentNo,
                time: x.StartTime,
                WorkDocNo: x.WorkDocNo,
                MouldBomNo: x.MouldBomNo,
                MouldNo: x.MouldNo,
              }
            })
          }
          resolve();
        })
      })
    },
    initOverviewCharts() {
      // 初始化设备概况的图表
      this.$nextTick(() => {
        if (this.$refs.rankChart && this.arr.length > 0) {
          this.$refs.rankChart.initChart(this.arr);
        }
        if (this.$refs.workChart && this.arr2.length > 0) {
          this.$refs.workChart.initChart(this.arr2);
        }
        // 初始化后立即resize一次
        setTimeout(() => {
          this.resizeEC();
        }, 100);
      });
    },
    // 实时数据相关方法
    initRealtime() {
      this.realtimePage = 1;
      this.getRealtimeData();
      if (this.isRealtimeLoop) {
        this.startRealtimeLoop();
      }
    },
    toggleRealtimeLoop() {
      this.isRealtimeLoop = !this.isRealtimeLoop;
      if (this.isRealtimeLoop) {
        this.startRealtimeLoop();
      } else {
        this.stopRealtimeLoop();
      }
    },
    startRealtimeLoop() {
      this.stopRealtimeLoop();
      this.realtimeTimer = setTimeout(async () => {
        this.realtimePage++;
        await this.getRealtimeData();
        if (this.realtimePage >= this.realtimePageMax) {
          this.realtimePage = 0;
        }
        if (this.isRealtimeLoop) {
          this.startRealtimeLoop();
        }
      }, 20000); // 每20秒切换一页
    },
    stopRealtimeLoop() {
      if (this.realtimeTimer) {
        clearTimeout(this.realtimeTimer);
        this.realtimeTimer = null;
      }
    },
    getRealtimeData() {
      return new Promise((resolve, reject) => {
        var params = { PageSize: 25, PageIndex: this.realtimePage };
        screenApi.eqRealtimeMould(params).then(res => {
          if (res.Code == 0) {
            this.realtimePageMax = Math.ceil(res.Count / params.PageSize);
            this.realtimeData = res.Data.map(x => {
              return {
                EquipmentName: x.EquipmentName,
                Status: x.Status,
                WarnStatus: x.WarnStatus,
                OperatingStatus: x.OperatingStatus,
                OrderNo: x.OrderNo,
                WorkDocNo: x.WorkDocNo,
                MouldBomNo: x.MouldBomNo,
                MouldName: x.MouldName,
                Cycn: x.Cycn,
                Et1: x.Et1,
                Et2: x.Et2,
                Et3: x.Et3,
                Et4: x.Et4,
                Et5: x.Et5,
                Et6: x.Et6,
                Et7: x.Et7,
                Et8: x.Et8,
                Et9: x.Et9,
                Et10: x.Et10,
                Eot: x.Eot,
              }
            });
          }
          resolve();
        })
      })
    },
    tableRowClassName({row}) {
      return row.WarnStatus == 1 ? 'warning-row' : '';
    },
    // 故障分析相关方法
    initAnalysis() {
      // 设备状态分析
      this.getDevStatus();
      // 月故障机台TOP5
      this.getFailureTop();
      // 实时故障告警
      this.getRealtimeFailure();
      // 周故障工时趋势
      this.getFailureWeek();
      // 周告警趋势
      this.getWarnWeek();
      // 月故障类型TOP5
      this.getFailureType();
      // 当天告警类型TOP5
      this.getDayWarnType();
      // 实时设备告警
      this.getRealtimeWarn();
    },
    getDevStatus() {
      screenApi.analysisDevFailure().then(res => {
        if (res.Code == 0) {
          this.devStatusData = [];
          // 故障在前，非故障在后，与图表渲染顺序一致
          this.devStatusData.push({ Name: '故障', Value: (res.Data.Failure * 100).toFixed(0) });
          this.devStatusData.push({ Name: '非故障', Value: (res.Data.Normal * 100).toFixed(0) });
          this.$nextTick(() => {
            this.initDevStatusChart();
          });
        }
      }).catch(err => {
        console.error('获取设备状态分析失败:', err);
      });
    },
    initDevStatusChart() {
      if (!this.$refs.devStatusChart) return;
      
      this.$nextTick(() => {
        const echarts = require('echarts');
        const chart = echarts.init(this.$refs.devStatusChart);
        const option = {
          series: [{
            type: 'pie',
            radius: ['60%', '80%'],
            data: this.devStatusData.map((item, index) => ({
              value: item.Value,
              name: item.Name,
              itemStyle: {
                color: index === 0 ? '#e7354b' : '#0cab75'
              }
            })),
            label: {
              show: true,
              formatter: '{b}: {c}%'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16
              }
            }
          }]
        };
        chart.setOption(option);
      });
    },
    getFailureTop() {
      screenApi.analysisFailureTop().then(res => {
        if (res.Data && res.Data.length > 0) {
          this.failureTopNoData = false;
          const data = res.Data.map(x => ({
            Name: x.EquipmentNo,
            Value: x.FailureHour
          }));
          this.$nextTick(() => {
            this.initFailureTopChart(data);
          });
        } else {
          this.failureTopNoData = true;
        }
      }).catch(err => {
        console.error('获取月故障机台TOP5失败:', err);
        this.failureTopNoData = true;
      });
    },
    initFailureTopChart(data) {
      if (!this.$refs.failureTopChart) return;
      
      this.$nextTick(() => {
        const echarts = require('echarts');
        const chart = echarts.init(this.$refs.failureTopChart);
        const option = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: data.map(x => x.Name),
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          color: ['#ff4d4f'],
          series: [{
            name: '故障工时',
            type: 'bar',
            data: data.map(x => x.Value),
            barMaxWidth: 50,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#303133'
                  }
                }
              }
            }
          }]
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      });
    },
    getRealtimeFailure() {
      screenApi.analysisFailureRealTime({ PageSize: 5, PageIndex: 1 }).then(res => {
        if (res.Code == 0 && res.Data) {
          this.realtimeFailureList = res.Data.map(x => ({
            EquipmentNo: x.EquipmentNo,
            FailureTime: x.FailureTime,
            FailureRemark: x.FailureRemark
          }));
        } else {
          this.realtimeFailureList = [];
        }
      }).catch(err => {
        console.error('获取实时故障告警失败:', err);
      });
    },
    getFailureWeek() {
      screenApi.analysisFailureWeek().then(res => {
        if (res.Data && res.Data.length > 0) {
          this.failureWeekNoData = false;
          const data = res.Data.map(x => ({
            Name: this.$commonJs.toDateStringByFormat(x.FailDay, 'MM-DD'),
            Value: x.FailHour
          }));
          this.$nextTick(() => {
            this.initFailureWeekChart(data);
          });
        } else {
          this.failureWeekNoData = true;
        }
      }).catch(err => {
        console.error('获取周故障工时趋势失败:', err);
        this.failureWeekNoData = true;
      });
    },
    initFailureWeekChart(data) {
      if (!this.$refs.failureWeekChart) return;
      
      this.$nextTick(() => {
        const echarts = require('echarts');
        const chart = echarts.init(this.$refs.failureWeekChart);
        const option = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: data.map(x => x.Name),
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          color: ['#fa8c16'],
          series: [{
            name: '故障工时',
            type: 'line',
            data: data.map(x => x.Value),
            smooth: true,
            symbolSize: 8,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#303133'
                  }
                }
              }
            }
          }]
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      });
    },
    getWarnWeek() {
      screenApi.analysisWarnWeek().then(res => {
        if (res.Data && res.Data.length > 0) {
          this.warnWeekNoData = false;
          const data = res.Data.map(x => ({
            Name: this.$commonJs.toDateStringByFormat(x.Warmday, 'MM-DD'),
            Value: x.WarmCnt
          }));
          this.$nextTick(() => {
            this.initWarnWeekChart(data);
          });
        } else {
          this.warnWeekNoData = true;
        }
      }).catch(err => {
        console.error('获取周告警趋势失败:', err);
        this.warnWeekNoData = true;
      });
    },
    initWarnWeekChart(data) {
      if (!this.$refs.warnWeekChart) return;
      
      this.$nextTick(() => {
        const echarts = require('echarts');
        const chart = echarts.init(this.$refs.warnWeekChart);
        const option = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: data.map(x => x.Name),
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          color: ['#ff0000'],
          series: [{
            name: '告警数量',
            type: 'line',
            data: data.map(x => x.Value),
            smooth: true,
            symbolSize: 8,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#303133'
                  }
                }
              }
            }
          }]
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      });
    },
    getFailureType() {
      screenApi.analysisFailureType().then(res => {
        if (res.Data && res.Data.length > 0) {
          this.failureTypeNoData = false;
          const data = res.Data.map(x => ({
            Name: x.FailureTypeName,
            Value: x.FailureCnt
          }));
          this.$nextTick(() => {
            this.initFailureTypeChart(data);
          });
        } else {
          this.failureTypeNoData = true;
        }
      }).catch(err => {
        console.error('获取月故障类型TOP5失败:', err);
        this.failureTypeNoData = true;
      });
    },
    initFailureTypeChart(data) {
      if (!this.$refs.failureTypeChart) return;
      
      this.$nextTick(() => {
        const echarts = require('echarts');
        const chart = echarts.init(this.$refs.failureTypeChart);
        const option = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: data.map(x => x.Name),
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          color: ['#409eff'],
          series: [{
            name: '故障次数',
            type: 'bar',
            data: data.map(x => x.Value),
            barMaxWidth: 50,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#303133'
                  }
                }
              }
            }
          }]
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      });
    },
    getDayWarnType() {
      screenApi.analysisWarnType().then(res => {
        if (res.Data && res.Data.length > 0) {
          this.dayWarnTypeNoData = false;
          const data = res.Data.map(x => ({
            Name: x.WarmId,
            Value: x.WarmCnt
          }));
          this.$nextTick(() => {
            this.initDayWarnTypeChart(data);
          });
        } else {
          this.dayWarnTypeNoData = true;
        }
      }).catch(err => {
        console.error('获取当天告警类型TOP5失败:', err);
        this.dayWarnTypeNoData = true;
      });
    },
    initDayWarnTypeChart(data) {
      if (!this.$refs.dayWarnTypeChart) return;
      
      this.$nextTick(() => {
        const echarts = require('echarts');
        const chart = echarts.init(this.$refs.dayWarnTypeChart);
        const option = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            top: '10%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: data.map(x => x.Name),
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#000'
            },
            splitLine: { show: false }
          },
          color: ['#fa8c16'],
          series: [{
            name: '告警次数',
            type: 'bar',
            data: data.map(x => x.Value),
            barMaxWidth: 50,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#303133'
                  }
                }
              }
            }
          }]
        };
        chart.setOption(option);
        window.addEventListener('resize', () => chart.resize());
      });
    },
    getRealtimeWarn() {
      screenApi.analysisRealtimeDevWarn({ PageSize: 5, PageIndex: 1 }).then(res => {
        if (res.Code == 0 && res.Data) {
          this.realtimeWarnList = res.Data.map(x => ({
            EquipmentNo: x.EquipmentNo,
            WarmMsg: x.WarmMsg,
            Warmtime: x.Warmtime
          }));
        } else {
          this.realtimeWarnList = [];
        }
      }).catch(err => {
        console.error('获取实时设备告警失败:', err);
      });
    }
  }
};
</script>
<style scoped lang="scss">
#overview {
  min-width: 1200px;
  min-height: 830px;
  padding: 4px;
  //background-color: #0B154A;
  background-color: #fff;
  // color: #fff;
  //height: calc(100vh - 84px);
  .top {
    .top-content {
      display: flex;
      align-items: center;
      padding: 10px;
      margin-bottom: 5px;
      .name {
        font-size: 18px;
        font-weight: bold;
        margin-right: 20px;
        white-space: nowrap;
      }
      .el-tabs {
        flex: 0 0 400px;
        max-width: 400px;
        ::v-deep .el-tabs__header {
          margin: 0;
        }
        ::v-deep .el-tabs__item {
          font-size: 17px;
          font-weight: 600;
          color: #606266;
          height: 50px;
          line-height: 50px;
          &.is-active {
            color: #409EFF;
            font-size: 18px;
            font-weight: 700;
          }
          &:hover {
            color: #409EFF;
          }
        }
      }
      .right-content {
        margin-left: auto;
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .time {
        font-size: 14px;
        color: #606266;
        white-space: nowrap;
      }
      .controls {
        white-space: nowrap;
      }
      .TopTab {
        // margin: auto;
        margin-left: 15px;
      }
    }
  }
  .left-top {
    padding: 0 10px;
    box-sizing: border-box;
    .number {
      border-bottom: 1px solid #ddd;
      display: flex;
      line-height: 60px;
      justify-content: space-between;
      padding: 0 8px;
      .num_box {
        margin-top: -2px;
        .num {
          color: #409eff;
          transform: translateY(2px);
          display: inline-block;
          font-size: 22px;
          font-weight: bold;
          margin-right: 6px;
        }
      }
    }
  }
  .pie {
    margin-top: 10px;
    padding: 19px 0;
    .progress {
      margin: auto;
      width: 180px; /* 容器宽度 */
      height: 180px; /* 容器高度 */
      border-radius: 50%; /* 使容器成为圆形 */
      position: relative; /* 定位父容器 */
      overflow: hidden; /* 隐藏超出部分 */
      position: relative;
      border: 1px solid #ddd;
      .ctext {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        font-size: 14px;
        height: 130px;
        width: 130px;
        text-align: center;
        padding: 40px 0;
        border-radius: 50%;
        // background-color: #0B154A;
        border: 1px solid #ddd;
        background-color: #fff;
        .cv {
          font-weight: bold;
          span {
            font-size: 28px;
          }
        }
      }
    }
  }
  .line-box {
    height: 306px;
    .boxTitle {
      margin: 4px 4px 4px 4px;
      float: left;
    }
  }
  .state {
    padding: 0 0 0 20px;
    height: 207px;
    position: relative;
    .name {
      line-height: 70px;
      font-size: 24px;
      font-weight: bold;
    }
    .item {
      display: flex;
      font-size: 14px;
      line-height: 30px;
      .label {
        width: 110px;
      }
    }
    .btn {
      position: absolute;
      right: 15px;
      bottom: 15px;
      width: 85px;
      line-height: 30px;
      text-align: center;
      color: #fff;
    }
  }
  .border {
    border: 1px solid #ddd;
  }
  .blank0 {
    background-color: #10A580;
  }
  .blank1 {
    background-color: #C3A526;
  }
  .blank2 {
    background-color: #B22849;
  }
  .blank3 {
    background-color: #6F7487;
  }
  .bg0 {
    background-color: rgba(21,164,122,.2);
  }
  .bg1 {
    background-color: rgba(243,207,38,.2);
  }
  .bg2 {
    background-color: rgba(219,54,93,.2);
  }
  .bg3 {
    background-color: rgba(137,144,153,.2);
  }
  .name{
    font-weight: bold;
  }

  .alltitle {
    display: flex;
    align-items: center;
  }

  .icon {
    float:left;
    margin: 4px 4px 4px 4px;
    img {
      height: 20px;
      width: 20px;
    }
  }

  .chart {
    margin-top: 12px;
  }

  // 实时数据容器
  .realtime-container {
    padding: 10px;

    .realtime-controls {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      padding: 0 10px;

      .pill-switch {
        margin-left: 10px;
      }
    }
  }

  // 药丸开关
  .pill-switch {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    .switch-track {
      width: 44px;
      height: 24px;
      background-color: #dcdfe6;
      border-radius: 12px;
      position: relative;
      transition: background-color 0.3s;

      .switch-knob {
        width: 20px;
        height: 20px;
        background-color: white;
        border-radius: 50%;
        position: absolute;
        top: 2px;
        left: 2px;
        transition: transform 0.3s;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

        &.active {
          transform: translateX(20px);
          background-color: #67c23a;
        }
      }
    }

    .switch-label {
      margin-left: 10px;
      font-size: 14px;
      color: #606266;
    }

    &:hover .switch-track {
      background-color: #c0c4cc;
    }

    &:hover .switch-track .switch-knob.active {
      background-color: #85ce61;
    }

    // 当开关激活时，轨道背景变为绿色
    &.active .switch-track {
      background-color: #95d475;
    }

    &.active:hover .switch-track {
      background-color: #85ce61;
    }

    // 小号样式
    &.small {
      .switch-track {
        width: 36px;
        height: 20px;

        .switch-knob {
          width: 16px;
          height: 16px;
          top: 2px;
          left: 2px;

          &.active {
            transform: translateX(16px);
          }
        }
      }

      .switch-label {
        margin-left: 8px;
        font-size: 12px;
      }
    }
  }

  // 设备列表浮动轮播开关
  .device-list-container {
    position: relative;
  }

  .device-loop-switch-float {
    position: absolute;
    top: 320px;
    right: 0;
    z-index: 10;
    padding: 10px;
  }

  // 故障分析卡片
  .analysis-card {
    background: white;
    border-radius: 4px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    height: 280px;
    display: flex;
    flex-direction: column;

    .chart-header {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebeef5;
      flex-shrink: 0;

      i {
        font-size: 18px;
        color: #409eff;
        margin-right: 8px;
      }

      span {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
      }
    }

    .no-data {
      text-align: center;
      padding: 70px 0;
      color: #909399;
      font-size: 14px;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  // 设备状态分析
  .status-item {
    display: flex;
    flex-direction: column;
    padding: 8px 15px;
  }

  .status-label {
    font-size: 16px;
    font-weight: bold;
    padding: 10px 15px;
    border-radius: 4px;
    color: white;
    text-align: center;
  }

  .failure-label {
    background-color: #ff4d4f;
  }

  .normal-label {
    background-color: #0cab75;
  }

  // 表格告警行
  .warning-row {
    background-color: #fff1f0;
  }

  // 紧凑表格样式
  .compact-table {
    ::v-deep .el-table__body tr {
      td {
        padding-top: 4px !important;
        padding-bottom: 4px !important;
      }
    }
    ::v-deep .el-table__header th {
      padding-top: 6px !important;
      padding-bottom: 6px !important;
    }
    ::v-deep .el-table__cell {
      font-size: 12px;
    }
  }
}
</style>